import { createRoute, notFound } from "@tanstack/react-router";

import { Status } from "core/models/error";
import { root } from "routes";

import Layout from "theme/ui/Layout";

import { query } from "areas/campaigns/data";
import Redeem from "areas/campaigns/pages/Redeem";
import NotFound from "areas/campaigns/pages/NotFound";


const _root = createRoute({
	getParentRoute: () => root,
	path: "campaigns",
	component: () => <Layout.Light />
});

const redeem = createRoute({
	getParentRoute: () => _root,
	path: "$id",
	loader: async ({ context, params }) => {
		const { queryClient } = context;
		try {
			await queryClient.ensureQueryData(query.get(params.id));
		} catch (err) {
			if (err.type === Status[404]) throw notFound();
			throw err;
		}
	},
	component: () => <Redeem />,
	notFoundComponent: () => <NotFound />,
	staticData: {
		lite: true
	}
});

const all = _root.addChildren([redeem]);
export default all;